import React from "react";
import { Modal, Button } from "antd";

const CustomModal = ({
  visible,
  onClose,
  title = "Bihar Biometric Authentication",
  content,
  onSubmit,
  isEditable = false,
  extraActions = [],
  hideFooter = false, // add a new prop
}) => {
  const renderFooter = () => {
    if (hideFooter) return null; // hide footer completely

    if (isEditable) {
      return [
        ...extraActions,
        <Button key="submit" type="primary" onClick={onSubmit}>
          Save
        </Button>,
        <Button key="cancel" onClick={onClose}>
          Close
        </Button>
      ];
    }

    return extraActions.length > 0 ? extraActions : null;
  };

  return (
    <Modal
      open={visible}
      title={title}
      onCancel={onClose}
      footer={renderFooter()}
    >
      {content}
    </Modal>
  );
};

export default CustomModal;
